<div class="login">
    <div class="container">
      <div class="image">
        <img src="assets/images/logobranco.svg" />
      </div>
      <div class="logo">
        <img src="assets/images/centralizenfs.png" />
      </div>
      <div class="inputlogin">
        <div class="label">Usuário</div>
        <input #userlogin [(ngModel)]="cliente.user" />
      </div>
      <div class="inputlogin">
        <div class="label">Senha</div>
        <input
          type="password"
          [(ngModel)]="cliente.password"
          (keyup.enter)="login()"
        />
      </div>
      <br />
      <div class="buttonlogin" (click)="login()">
        <label> Login </label>
      </div>
      <br />
    </div>
  </div>
  <spinner *ngIf="inlogin">Entrando...</spinner>
  <div class="version">Versão: {{version.version_text}}</div>